import React from 'react';
import dayjs from 'dayjs';
import clsx from 'classnames';
import { ChevronRight, Coffee } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import taskStyles from '../SchedulerTask/SchedulerTask.module.scss';
import styles from './OverlapTaskCard.module.scss';
import { getClientDisplayName, getPrimaryServiceName, isCalendarBreak } from '../utils/taskDisplay';

const getCardOpacity = (task) => {
  if (task.dragged) return 0.8;
  if (task.matched) return 1;
  if (!task.isActive) return 0.5;
  return task.opacity || 1;
};

const OverlapTaskCard = ({ task, onClick, className }) => {
  const { t } = useTranslation();
  const isBreak = isCalendarBreak(task);
  const serviceLabel = getPrimaryServiceName(task.servizi) || 'Prenotazione';
  const clientLabel = getClientDisplayName(task);
  const timeLabel = `${dayjs(task.orario_start, 'HH:mm:ss').format('HH:mm')} – ${dayjs(
    task.orario_end,
    'HH:mm:ss',
  ).format('HH:mm')}`;
  const pauseLabel = t('scheduler.schedulerWorker.status.pause');

  return (
    <button
      type="button"
      className={clsx(
        taskStyles.card_container,
        taskStyles.card_container_preview,
        { [taskStyles.card_break]: isBreak },
        className,
      )}
      style={
        isBreak
          ? { color: '#8A5420', '--task-ink': '#8A5420', opacity: getCardOpacity(task) }
          : { background: task.color, opacity: getCardOpacity(task) }
      }
      onClick={onClick}
    >
      {isBreak ? (
        <div className={taskStyles.break_body}>
          <span className={taskStyles.break_badge}>
            <Coffee size={16} strokeWidth={2.4} aria-hidden="true" />
            {pauseLabel}
          </span>
          <span className={taskStyles.break_time}>{timeLabel}</span>
        </div>
      ) : (
        <div className={styles.content}>
          <div className={styles.text_block}>
            <div className={styles.service}>{serviceLabel}</div>
            <span className={styles.client}>{clientLabel}</span>
            <div className={styles.time}>{timeLabel}</div>
          </div>
          <ChevronRight className={styles.arrow} size={18} strokeWidth={2.5} aria-hidden="true" />
        </div>
      )}
    </button>
  );
};

export default OverlapTaskCard;
